import { render, staticRenderFns } from "./roleMember.vue?vue&type=template&id=565cf3cc&scoped=true&"
import script from "./roleMember.vue?vue&type=script&lang=js&"
export * from "./roleMember.vue?vue&type=script&lang=js&"
import style0 from "./roleMember.vue?vue&type=style&index=0&id=565cf3cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565cf3cc",
  null
  
)

export default component.exports